import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'

@Component({})
export default class CompanySelectionModal extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: Boolean, default: false }) show!: boolean
  @Prop({ type: Object, default: {} }) current!: orgmap.Company
  @Prop({ type: Array, default: [] }) companies!: orgmap.Company[]
  @Prop({ type: Function, default: () => 1 }) onClose!: () => void
  @Prop({ type: Function, default: () => 1 }) onSelect!: () => void
}
